// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Skeleton_skeleton__8CwSX {
  display: block;
  position: relative;
  overflow: hidden;
  background: var(--dylo-sk-base);
  border-radius: 8px;
}
/* Onda: banda de luz diagonal que barre de esquina a esquina (igual que el loading de cards) */
.Skeleton_skeleton__8CwSX::after {
  content: '';
  position: absolute;
  top: -60%;
  left: 0;
  width: 55%;
  height: 220%;
  background: linear-gradient(
    90deg,
    transparent 0%,
    var(--dylo-sk-wave) 50%,
    transparent 100%
  );
  transform: rotate(16deg) translateX(-260%);
  animation: Skeleton_sk-diag-sweep__nBHUu 1.5s ease-in-out infinite;
}
@keyframes Skeleton_sk-diag-sweep__nBHUu {
  0% { transform: rotate(16deg) translateX(-260%); }
  100% { transform: rotate(16deg) translateX(380%); }
}
.Skeleton_circle__wJCll {
  border-radius: 50%;
}

.Skeleton_text__YUFRJ {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/v2/components/ui/Skeleton/Skeleton.module.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;EAC/B,kBAAkB;AACpB;AACA,+FAA+F;AAC/F;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,UAAU;EACV,YAAY;EACZ;;;;;GAKC;EACD,0CAA0C;EAC1C,kEAAkD;AACpD;AACA;EACE,KAAK,0CAA0C,EAAE;EACjD,OAAO,yCAAyC,EAAE;AACpD;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV","sourcesContent":[".skeleton {\n  display: block;\n  position: relative;\n  overflow: hidden;\n  background: var(--dylo-sk-base);\n  border-radius: 8px;\n}\n/* Onda: banda de luz diagonal que barre de esquina a esquina (igual que el loading de cards) */\n.skeleton::after {\n  content: '';\n  position: absolute;\n  top: -60%;\n  left: 0;\n  width: 55%;\n  height: 220%;\n  background: linear-gradient(\n    90deg,\n    transparent 0%,\n    var(--dylo-sk-wave) 50%,\n    transparent 100%\n  );\n  transform: rotate(16deg) translateX(-260%);\n  animation: sk-diag-sweep 1.5s ease-in-out infinite;\n}\n@keyframes sk-diag-sweep {\n  0% { transform: rotate(16deg) translateX(-260%); }\n  100% { transform: rotate(16deg) translateX(380%); }\n}\n.circle {\n  border-radius: 50%;\n}\n\n.text {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"skeleton": `Skeleton_skeleton__8CwSX`,
	"sk-diag-sweep": `Skeleton_sk-diag-sweep__nBHUu`,
	"circle": `Skeleton_circle__wJCll`,
	"text": `Skeleton_text__YUFRJ`
};
export default ___CSS_LOADER_EXPORT___;
